import { MemberStatus } from '@common/modules/settings/enums/member-status.enum'
import type { WorkspaceMember, WorkspaceMemberRole } from '@common/modules/settings/types/workspace-member.type'

export function buildPendingWorkspaceMember(
  email: string,
  role: WorkspaceMemberRole,
  projectId: string
): WorkspaceMember {
  return {
    id: `workspace-member-${Date.now()}-${email}`,
    name: null,
    email,
    avatarUrl: null,
    role,
    status: MemberStatus.PENDING,
    lastSeen: null,
    projectIds: [projectId],
    projectsCount: 1,
  }
}
